import { ReactNode } from 'react';
import { FormCheckType } from 'types/common';
import { HomeAddressTypeEnum } from 'types/customer';
import { ChnHomeAddressProps } from './ChnHomeAddress';
import { Common2HomeAddressProps } from './Common2HomeAddress';
import { CommonHomeAddressProps } from './CommonHomeAddress';
import { UsaHomeAddressProps } from './UsaHomeAddress';

interface BaseHomeAddressFormutil {
    home_address_type: HomeAddressTypeEnum;
    home_city: string;
}

export interface UsaHomeAddressFormutil extends BaseHomeAddressFormutil {
    home_address: string;
    home_address2: string;
    home_state_code: string;
    home_postal: string;
    same_delivery_and_residence: FormCheckType;
}

/**
 * 字段参考： https://apidocs.tigerfintech.com/repository/1/markdown/master/docs/%E5%BC%80%E6%88%B7%E5%AD%97%E6%AE%B5%E6%9E%9A%E4%B8%BE-%E4%B8%AA%E4%BA%BA.md
 */
export interface Common2HomeAddressFormutil extends BaseHomeAddressFormutil {
    home_country: string;
    home_detail: string;
    home_detail2: string;
    home_state_code: string;
    home_postal: string;
    same_delivery_and_residence: FormCheckType;
}

export interface ChnHomeAddressFormutil extends BaseHomeAddressFormutil {
    home_state: string;
    home_district: string;
    home_detail: string;
    has_delivery_address: boolean;
}

export interface CommonHomeAddressFormutil extends BaseHomeAddressFormutil {
    home_state: string;
    home_detail: string;
    home_postal: string;
}

export type HomeAddressFormutil = UsaHomeAddressFormutil &
    ChnHomeAddressFormutil &
    CommonHomeAddressFormutil &
    Common2HomeAddressFormutil;

export interface BaseHomeAddressProps {
    disabled?: boolean;
    label?: ReactNode;
    className?: string;
    prefix: 'home' | 'delivery';
}

export interface HomeAddressProps
    extends ChnHomeAddressProps,
        UsaHomeAddressProps,
        CommonHomeAddressProps,
        Common2HomeAddressProps {
    isSSN: boolean;
    homeAddressType?: HomeAddressTypeEnum;
    legalResidenceCountry?: string;
}
